import React from 'react';

const Button = ({ children, className, onClick, iconClass, disabled }) => {
  // Full width is only a default. Tailwind emits `.w-full` after the numbered
  // widths, so a caller passing `w-10` would lose to it no matter where their
  // class lands in the string below — the +/- steppers ended up full width and
  // pushed their own label and sibling button out of the row. Drop the default
  // whenever the caller sets a width of their own.
  const hasWidth = /(?:^|\s)w-/.test(className || '');

  return (
    <button
      type="button"
      className={`
        ${hasWidth ? '' : 'w-full'} h-10
        inline-block 
        font-normal 
        text-white text-center 
        align-middle 
        select-none 
        bg-accentDark 
        px-3 py-1.5
        text-base 
        leading-6 
        border-0 rounded-md 
        transition-colors duration-150 ease-in-out 
        hover:bg-accentLight 
        disabled:bg-lightColor
        ${className}
      `}
      onClick={() => onClick && onClick()}
      disabled={disabled}>
      {children} {iconClass && <i className={iconClass} />}
    </button>
  );
};

export default Button;
